import React from 'react';
import PropTypes from 'prop-types';
import Box from 'core/ui/Box';
import { ButtonPrimary } from 'core/ui/Button';
import LoaderSm from 'core/ui/LoaderSm';
import { useTranslation } from 'react-i18next';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import AdminChannelSelector from 'components/Admin/ChannelSelector';
import useSelectors from 'modules/map/useSelectors';
import { salesUsersChannelsModule } from 'modules/salesUsersChannels';
import useFormSalesUserChannel from './useForm';

const FormPartner = ({ salesUserChannelId, userId, close, callbackSave }) => {
  const { t } = useTranslation();
  const loading = useSelectors(salesUsersChannelsModule, 'loadingForm');
  const { errors, setValue, watch, submit } = useFormSalesUserChannel({
    salesUserChannelId,
    userId,
    callbackSave,
    close,
  });

  return (
    <Box className="tw-flex tw-flex-col tw-gap-4">
      <AdminChannelSelector
        selectedChannel={watch('channel')}
        setSelectedChannel={(v) => setValue('channel', v)}
      />
      <div>
        <TextFieldRounded
          placeholder="0,00"
          label={t('label.percent').toUpperCase()}
          value={watch('percent')}
          onChange={(v) => setValue('percent', v)}
          error={errors?.percent}
          type="number"
          pattern="[1-9]*"
        />
      </div>

      <Box mb={5} display="flex" justifyContent="flex-end">
        <ButtonPrimary
          type="button"
          onClick={() => submit()}
          size="small"
          disabled={loading}
          style={{ height: 30, width: 80, borderRadius: 5 }}
        >
          <LoaderSm loading={loading} width={20} />
          {t('button.save')}
        </ButtonPrimary>
      </Box>
    </Box>
  );
};

FormPartner.propTypes = {
  close: PropTypes.func.isRequired,
};

FormPartner.defaultProps = {};

export default FormPartner;
